<script>
export default {
  name: 'DataLayer',
  props: ['solutionBuilderName', 'screenTitle', 'screenNumber', 'screenTotal', 'userSelection', 'eventChange', 'prevPage', 'prevScreenTitle', 'userPrevSelection'],
  data() {
    return {
      userAnswers: {},
      event: 'builder_launched',
    };
  },
  methods: {
    pushData() {
      window.dataLayer = window.dataLayer || [];

      const event = this.event;
      let dataLayer = {};
      switch (event) {
        case 'builder_launched':
          dataLayer = {
            'event': event,
            'solutionBuilderName': this.solutionBuilderName,
            'pageUrl': window.location.href, // url
            'pageName': document.title, // sitecore content page name
            'screenTitle': this.screenTitle, // title of page
          }
          break;
        case 'screen_click_next':
          dataLayer = {
            'event': event,
            ...this.dataLayer
          }

          // Saving answers in more readable format for builder_completed payload
          this.userAnswers[this.dataLayer.screenTitle] = this.dataLayer.userSelection;

          // Need to save previous for next/prev clicks
          break;
        case 'screen_click_previous':
          dataLayer = {
            'event': event,
            ...this.dataLayer
          }
          // Need to save previous for next/prev clicks
          break;
        case 'builder_completed':
          dataLayer = {
            'event': event,
            'solutionBuilderName': this.solutionBuilderName,
            'screenTitle': this.screenTitle, // title of page
            'userAnswers': JSON.stringify(this.userAnswers).replaceAll('"', "'").replaceAll(/[\\{}]/g, ""),
          }

          this.$store.state.userAnswers = this.userAnswers;
          console.log('store.userAnswers: ', this.$store.state.userAnswers);
          break;
          default:
            dataLayer = {
              'event': 'error',
              'solutionBuilderName': this.solutionBuilderName,
              'screenNumber': this.screenNumber, // current page
              'screenTotal': this.screenTotal, // page total
              'userSelection': this.userSelection,
            }

      }
      console.log(dataLayer)
      window.dataLayer.push(dataLayer);
      // 'screen_impression' event always happens on page change
      dataLayer = {
        'event': 'screen_impression', // event needs to change based on what user does
        'solutionBuilderName': this.solutionBuilderName,
        'screenTitle': this.screenTitle, // title of page
        'screenNumber': this.screenNumber, // current page
        'screenTotal': this.screenTotal, // page total
      }
      console.log(dataLayer)
      window.dataLayer.push(dataLayer);
    },
  },
  computed: {
    dataLayer() {
      return {
        'solutionBuilderName': this.solutionBuilderName,
        'screenNumber': this.prevPage,
        'screenTitle': this.prevScreenTitle, // title of page
        'screenTotal': this.screenTotal, // page total
        'userSelection': this.userPrevSelection || 'N/A',
      }
    },
  },
  mounted() {
    this.pushData();
  },
  watch: {
    screenNumber() { // pushData when user changes question number
      if (this.screenNumber === 11) {
        this.event = 'builder_completed';
        this.pushData();
      }

      if (this.screenNumber > this.prevPage) {
        this.event = 'screen_click_next';
      } else {
        this.event = 'screen_click_previous';
      }
      this.pushData();
    },
    userSelection() {
      console.log(this.userSelection);
    }
  }
}
</script>